"use strict";

(function ($, Drupal) {
  Drupal.behaviors.headerOffset = {
    attach: function attach(context, settings) {
      const preHeaderRegion = document.getElementById('region--pre-header');

      if (!preHeaderRegion) return;

      const updateHeaderOffset = function() {
        const messagesBlock = preHeaderRegion.querySelector('[data-drupal-messages]');
        const messagesHeight = messagesBlock && messagesBlock.querySelector('.messages')
          ? messagesBlock.offsetHeight
          : 0;

        // Update CSS custom property
        document.documentElement.style.setProperty('--messages-height', messagesHeight + 'px');
      };

      // Initial check
      updateHeaderOffset();

      // Watch for changes in the pre-header region
      const observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
          if (mutation.addedNodes.length || mutation.removedNodes.length) {
            updateHeaderOffset();
          }
        });
      });

      // Observe the pre-header region for changes
      observer.observe(preHeaderRegion, {
        childList: true,
        subtree: true
      });

      // Also update on window resize
      window.addEventListener('resize', updateHeaderOffset);
    }
  };
})(jQuery, Drupal);
